import React, { Component } from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';

export const withToken = (WrappedComponent) => {
  class UserCheckerUnwrapped extends Component {
    render() {
      return (<WrappedComponent {...this.props} />);
    }
  }

  UserCheckerUnwrapped.propTypes = {
    apiToken: PropTypes.string.isRequired,
    user: ImmutablePropTypes.map.isRequired,
    authorities: ImmutablePropTypes.list.isRequired,
  };

  const mapStateToProps = state => ({
    apiToken: state.getIn(['loginPage', 'apiToken']),
    user: state.getIn(['loginPage', 'user']),
    authorities: state.getIn(['loginPage', 'user', 'authorities']),
  });

  return connect(mapStateToProps, null)(UserCheckerUnwrapped);
};
